export const Types = {
  SET_FILTRO: "dashboard/SET_FILTRO",
  SET_DATA_GRAPH_DASHBOARD: "dashboard/SET_DATA_GRAPH_DASHBOARD",
  SET_DATA_BAR_GRAPH_DASHBOARD: "dashboard/SET_DATA_BAR_GRAPH_DASHBOARD",
  SET_SALES_DASHBOARD: "dashboard/SET_SALES_DASHBOARD"
};

const INITIAL_STATE = {
  filtroPropostas: null,
  filtroPromotores: null,
  dataGraph: [],
  dataBarGraph: [],
  sales: ""
};

export default function dashboard(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.SET_FILTRO:
      return {
        ...state,
        filtroPropostas: action.payload.filtroPropostas,
        filtroPromotores: action.payload.filtroPromotores
      };
    case Types.SET_DATA_GRAPH_DASHBOARD:
      return {
        ...state,
        dataGraph: action.payload.dataGraph
      };
    case Types.SET_DATA_BAR_GRAPH_DASHBOARD:
      return {
        ...state,
        dataBarGraph: action.payload.dataBarGraph
      };
    case Types.SET_SALES_DASHBOARD:
      return {
        ...state,
        sales: action.payload.sales
      };
    default:
      return state;
  }
}

export const Creators = {
  setFiltroDashboard: (filtroPropostas, filtroPromotores) => ({
    type: Types.SET_FILTRO,
    payload: { filtroPropostas, filtroPromotores }
  }),
  setDataGraphDashboard: dataGraph => ({
    type: Types.SET_DATA_GRAPH_DASHBOARD,
    payload: { dataGraph }
  }),
  setDataBarGraphDashboard: dataBarGraph => ({
    type: Types.SET_DATA_BAR_GRAPH_DASHBOARD,
    payload: { dataBarGraph }
  }),
  setSalesDashboard: sales => ({
    type: Types.SET_SALES_DASHBOARD,
    payload: { sales }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/dashboard.js